import axios from 'axios';

// const basePath ="http://10.1.6.14:8081/website";
const basePath="https://website.manager.kayakwise.com";
let request={}
request.basePath=basePath
request.get=function (data) {
  return new Promise((resolve, reject) => {
    axios({
      method: "GET",
      url: localStorage.getItem("requestHeaher") + data.url,
      data: data.params,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    }).then(res => {
      resolve(res)
    }).catch(function(err) {
      console.log(err);
    });
  });
}

request.post=function (data) {
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: basePath + data.url,
      data: data.params,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    }).then(res => {
      resolve(res)
    }).catch(function(err) {
      console.log(err);
    });
  });
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js